import { inject, WritableSignal, signal } from "@angular/core";
import { CalculationTodayStoreService } from "@vault/web-vault/app/services/store/calculation-today/calculation-today.store.service";
import { ImportStoreService } from "@vault/web-vault/app/services/store/import/import.store.service";
import { UserStoreService } from "@vault/web-vault/app/services/store/user/user.store.service";
import { SignalSubscriptionImpl } from "../../data-subscription";
import { getAccountTableViews } from "../account.table";
import { compareByInstitutionThenName, filterAccountRows } from "./account-details-table.utils";

export type {
  TableSource,
  AccountManualTypeFilter,
  AccountOriginFilter,
  TableFilter,
} from "./account-details-table.utils";
import type { TableFilter, TableSource } from "./account-details-table.utils";

/**
 * This class only need to deal with angular dependency
 * and the core logic is in getAccountTableViews function which can be easily unit tested
 */
export class AccountDetailsTableSubscription extends SignalSubscriptionImpl<TableSource[]> {
  protected filter: WritableSignal<TableFilter> = signal<TableFilter>(null);
  userStoreService: UserStoreService;
  importStoreService: ImportStoreService;
  calculationStoreService: CalculationTodayStoreService;

  constructor() {
    super();
    this.userStoreService = inject(UserStoreService);
    this.importStoreService = inject(ImportStoreService);
    this.calculationStoreService = inject(CalculationTodayStoreService);
  }

  get source() {
    const balances = this.calculationStoreService.balanceByAccount.balances();
    const institutionViews = this.userStoreService.institutions.institutionViews();
    const preference = this.userStoreService.preferences.preferenceView();
    const syncStatusViews = this.importStoreService.syncStatus.syncStatusViews();
    const filter = this.filter();
    const accountViews = this.userStoreService.enrichAccounts.collection();
    const accountTableViews = getAccountTableViews(
      accountViews,
      syncStatusViews,
      institutionViews,
      balances,
      preference,
    );
    const filtered = filterAccountRows(filter, accountTableViews);
    return filtered ? [...filtered].sort(compareByInstitutionThenName) : filtered;
  }

  setFilter(filter: TableFilter) {
    // filter may has same reference, so we need to create a new object
    // also we know value of the key in filter is always different
    this.filter.set({ ...filter });
  }
}
